// Trainee "course language" selection — filters which language's courses are shown on the
// Explore feed and Topics list. Defaults to the language passed from the Loyalty app SSO
// (stored under `lms.locale`), then persists the learner's manual choice. Kept separate from
// the Devnagri UI-translation widget (that translates static UI text; this filters content).
import { useEffect, useState } from 'react';

const KEY = 'lms.course_lang';
const LOCALE_KEY = 'lms.locale';
const EVT = 'lms-course-lang';

export function getCourseLang() {
    try {
        return localStorage.getItem(KEY) || localStorage.getItem(LOCALE_KEY) || 'en';
    } catch {
        return 'en';
    }
}

export function setCourseLang(lang) {
    try { localStorage.setItem(KEY, lang); } catch { /* ignore */ }
    window.dispatchEvent(new CustomEvent(EVT, { detail: lang }));
}

export function useCourseLang() {
    const [lang, setLang] = useState(getCourseLang);
    useEffect(() => {
        const h = (e) => setLang((e && e.detail) || getCourseLang());
        window.addEventListener(EVT, h);
        return () => window.removeEventListener(EVT, h);
    }, []);
    return [lang, setCourseLang];
}
